import { render, staticRenderFns } from "./DialogEditReceiptConfig.vue?vue&type=template&id=7fbb0169"
import script from "./DialogEditReceiptConfig.vue?vue&type=script&lang=js"
export * from "./DialogEditReceiptConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports